export default function SEOContent() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <article className="prose prose-lg max-w-none">
          <h2 className="text-3xl font-bold text-slate-900 mb-6">
            Betrouwbare Airport Taxi Service in Utrecht
          </h2>
          
          <p className="text-slate-700 leading-relaxed mb-6">
            Op zoek naar een <strong>betrouwbare airport taxi in Utrecht</strong>? Utrecht Airport Taxi biedt professioneel vervoer naar alle grote luchthavens in Nederland en België. Of u nu naar Schiphol, Eindhoven Airport, Rotterdam The Hague Airport of Brussels Airport moet, wij zorgen voor comfortabel en tijdig vervoer.
          </p>

          <h3 className="text-2xl font-bold text-slate-900 mb-4 mt-8">
            Waarom kiezen voor Utrecht Airport Taxi?
          </h3>
          
          <p className="text-slate-700 leading-relaxed mb-6">
            Onze <strong>airport taxi service</strong> onderscheidt zich door betrouwbaarheid, comfort en transparante prijzen. Wij begrijpen dat reizen naar de luchthaven stressvrij moet zijn. Daarom bieden wij voor veel ritten een vaste prijs aan, zodat u precies weet waar u aan toe bent.
          </p>

          <p className="text-slate-700 leading-relaxed mb-6">
            Onze chauffeurs zijn ervaren professionals die bekend zijn met alle routes en luchthavens. Ze houden rekening met verkeerssituaties en zorgen ervoor dat u ruim op tijd aankomt voor uw vlucht. Ook voor ophaalritten vanaf de luchthaven kunt u op ons rekenen – geef uw vluchtnummer door en wij volgen uw aankomst.
          </p>

          <h3 className="text-2xl font-bold text-slate-900 mb-4 mt-8">
            Service in heel Utrecht en omgeving
          </h3>
          
          <p className="text-slate-700 leading-relaxed mb-6">
            Wij bedienen de gehele regio Utrecht, inclusief alle wijken en omliggende plaatsen. Of u nu in <strong>Leidsche Rijn</strong>, <strong>Utrecht Centrum</strong>, <strong>Overvecht</strong>, <strong>De Meern</strong>, <strong>Kanaleneiland</strong> of een andere wijk woont – onze <strong>taxi service</strong> is altijd beschikbaar.
          </p>

          <p className="text-slate-700 leading-relaxed mb-6">
            Ook vanuit omliggende plaatsen zoals <strong>Nieuwegein</strong>, <strong>IJsselstein</strong>, <strong>Houten</strong>, <strong>Zeist</strong>, <strong>De Bilt</strong>, <strong>Bunnik</strong>, <strong>Maarssen</strong> en <strong>Woerden</strong> verzorgen wij dagelijks airport transfers.
          </p>

          <h3 className="text-2xl font-bold text-slate-900 mb-4 mt-8">
            24/7 beschikbaar voor al uw airport transfers
          </h3>
          
          <p className="text-slate-700 leading-relaxed mb-6">
            Vluchten vertrekken op alle tijden van de dag en nacht. Daarom is onze <strong>airport taxi service</strong> 24 uur per dag, 7 dagen per week beschikbaar. Of u nu een vroege ochtendvlucht heeft of laat in de avond aankomt – wij staan voor u klaar.
          </p>

          <p className="text-slate-700 leading-relaxed mb-6">
            Reserveren is eenvoudig via telefoon of WhatsApp. Geef uw ophaaladres, bestemming, datum en tijd door, en wij regelen de rest. Voor veel ritten kunnen we direct een vaste prijs afspreken, zodat u geen verrassingen krijgt.
          </p>

          <h3 className="text-2xl font-bold text-slate-900 mb-4 mt-8">
            Comfortabel reizen met ruimte voor bagage
          </h3>
          
          <p className="text-slate-700 leading-relaxed mb-6">
            Onze taxi's zijn ruim en comfortabel, met voldoende ruimte voor uw bagage. Of u nu alleen reist of met een groep, wij hebben altijd een passende oplossing. Onze chauffeurs helpen u graag met het in- en uitladen van uw koffers.
          </p>

          <p className="text-slate-700 leading-relaxed">
            Kies voor zekerheid, comfort en betrouwbaarheid. Kies voor <strong>Utrecht Airport Taxi</strong> – uw specialist in airport transfers vanuit Utrecht en omgeving.
          </p>
        </article>
      </div>
    </section>
  );
}
